import React from 'react'
import PropTypes from 'prop-types'
import {
  PageFooterMain,
  PageFooterWrapper,
  CMSButtonContainer
} from './index.style'
import Container from '@components/Container'
import { colors } from '@styles/vars/colors.style'
import Spacer from '@components/Spacer'
import CMSButton from '@components/CMSButton'
import IconArrowRight from '@svgs/IconArrowRight'
import RichText from '@components/RichText'


const PageFooter = ({
  content
}) => {

  const { title, text, image, link } = content
  const background = content.backgroundColour
    ? content.backgroundColour
    : colors.charcoal
  const color = content.textColour ? content.textColour : colors.white

  return (
    <PageFooterMain color={color} background={background} id="footerMain">
      <Container>
        <PageFooterWrapper>
          <Spacer size={[30, 60]} />
          <RichText
              content={text}
              maxWidth={80}
              paragraphSize="heading1Serif"
          />
          <Spacer size={[40, 60]} />
          <CMSButtonContainer>
            <CMSButton
              link={link}
              className="contactLink"
              iconRight={<IconArrowRight />}
              enterFrom="left"
            />
          </CMSButtonContainer>
          <Spacer size={[20, 40]} />
        </PageFooterWrapper>
      </Container>
    </PageFooterMain>
  )
}

PageFooter.propTypes = {
  content: PropTypes.object
}

export default PageFooter
